// libs
import React, { memo } from 'react';
import cx from 'classnames';
// widgets
import RecentlyAddedTag from '@/widgets/RecentlyAddedTag';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg16 as CloseIcon } from '@swiggy-private/dls-web-icons/dist/web/generic/close';
// constant
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// stores
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
// styles
import style from '@/widgets/Table/Table.module.scss';
import productStyle from '../ProductTable.module.scss';
// helpers
import { getCloudinaryUrl } from '@/helpers/cloudinary';
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
import { getParsedMetricValue } from '@/helpers/utils';
import { PRODUCT_TABLE_COLUMNS } from '@/pages/instamart/campaign/details/helpers';
const IMAGE_HEIGHT_WIDTH = 44;
const ProductImage = ({ row }) => {
    var _a, _b;
    const getTextProductName = (text) => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Highest_Emphasis }, text));
    };
    return (React.createElement("div", { className: productStyle.container },
        React.createElement("img", { src: getCloudinaryUrl(row.creativeId, {
                width: IMAGE_HEIGHT_WIDTH * 2,
                height: IMAGE_HEIGHT_WIDTH * 2,
            }), className: productStyle.image }),
        React.createElement("div", null,
            React.createElement("span", { className: productStyle.productname }, getTextProductName(row.name)),
            ((_a = row.variants) === null || _a === void 0 ? void 0 : _a.length) !== 0 && (React.createElement("span", { className: productStyle.productVariants }, (_b = row.variants) === null || _b === void 0 ? void 0 : _b.map((variant, index) => (React.createElement(Text, { key: index, variant: DlsFontVariants.body_B2_Reg, color: DlsColorTokens.text_Low_Emphasis }, variant))))))));
};
const ProductTableRow = ({ mode, row, stale, preSelectedProducts, onDelete, }) => {
    const showRecentlyAddedBadge = mode === CampaignWriteModeEnum.EDIT &&
        !(preSelectedProducts === null || preSelectedProducts === void 0 ? void 0 : preSelectedProducts.some((product) => product.id === row.id));
    const getText = (text) => {
        return (React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_Med_Emphasis }, text));
    };
    return (React.createElement("ul", { className: cx(style.tableRow, style.rowList, productStyle.outerContainer, {
            [productStyle.staleProductRow]: stale,
        }) },
        showRecentlyAddedBadge && React.createElement(RecentlyAddedTag, null),
        React.createElement("li", { style: {
                width: PRODUCT_TABLE_COLUMNS[0].width,
                textAlign: 'left',
            } },
            React.createElement(ProductImage, { row: row })),
        React.createElement("li", { style: {
                width: PRODUCT_TABLE_COLUMNS[1].width,
            } }, getText(prefixWithRupee(getParsedMetricValue(formatNumberIntl({
            value: row.spend,
        }))))),
        React.createElement("li", { style: {
                width: PRODUCT_TABLE_COLUMNS[1].width,
            } }, getText(getParsedMetricValue(formatNumberIntl({
            value: row.impression,
        })))),
        React.createElement("li", { style: {
                width: PRODUCT_TABLE_COLUMNS[1].width,
            } }, getText(getParsedMetricValue(formatNumberIntl({
            value: row.addToCart,
        })))),
        React.createElement("li", { style: {
                width: PRODUCT_TABLE_COLUMNS[1].width,
            } }, getText(prefixWithRupee(getParsedMetricValue(formatNumberIntl({
            value: row.gmv,
        }))))),
        React.createElement("li", { style: {
                width: PRODUCT_TABLE_COLUMNS[3].width,
            } }, getText(getParsedMetricValue(formatNumberIntl({
            value: row.roi,
        })))),
        mode === CampaignWriteModeEnum.EDIT && (React.createElement("li", null,
            React.createElement("div", { className: style.deleteIcon },
                React.createElement("span", { onClick: () => onDelete === null || onDelete === void 0 ? void 0 : onDelete(row.id) },
                    React.createElement(GenericIcon, { Icon: CloseIcon, fillColor: DlsColorTokens.text_Low_Emphasis })))))));
};
export default memo(ProductTableRow);
